import { BaseModel } from './base.model';
import { ListModel } from './list.model';
import { HeaderItemType } from '../enum/header-item-type';

export class HeaderItemModel extends BaseModel {

    description: string;
    required: boolean;
    header_item_type: number;
    list_id: number;
    dyn_list_id: number;
    checklist_id: number;
    list: ListModel;
    itemOrder: number;
    type: object;
    response: string;
    primary: boolean;
    [x:string]: any;
    static validate(headerItem: HeaderItemModel): boolean {
        if(headerItem.description && headerItem.header_item_type) {
            if(headerItem.header_item_type == HeaderItemType['Lista Simples'] && !headerItem.list_id) {
                return false;
            }
            return true;
        }
        return false;
    }

    constructor(headerItem?: HeaderItemModel) {
        super();
        this.description = headerItem ? headerItem.description || null : null;
        this.required = headerItem ? headerItem.required || null : null;
        this.header_item_type = headerItem ? headerItem.header_item_type || null : null;
        this.list_id = headerItem ? headerItem.list_id || null : null;
        this.dyn_list_id = headerItem ? headerItem.dyn_list_id || null : null;
        this.checklist_id = headerItem ? headerItem.checklist_id || null : null;
        this.list = headerItem ? headerItem.list || null : null;
        this.type = headerItem ? headerItem.type || null : null;
        this.response = headerItem ? headerItem.response || null : null;
        this.primary = headerItem ? headerItem.primary || null : null;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/header-item.model.ts